export default __webpack_public_path__ + "static/cre-main-image-0eba1745f86a0ec7b83303e9eb592773.png";